//Datagrid MUI
import { DataGrid, esES } from '@mui/x-data-grid';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import TabPanel from '@mui/lab/TabPanel';

import { REGULAR_CUSTOMERS_COLUMNS } from '../../../../constants/admin/dashboard_constants';

const themeLanguaje = createTheme(
    esES
);

const RegularCustomersRange = ({ value, rows }) => {
    return (
        <TabPanel value={value}>
            <div style={{ height: 434.5, width: '100%' }}>
                <ThemeProvider theme={themeLanguaje}>
                    <DataGrid
                        rows={rows}
                        columns={REGULAR_CUSTOMERS_COLUMNS}
                        pageSize={5}
                        rowsPerPageOptions={[5]}
                        disableSelectionOnClick
                    />
                </ThemeProvider>
            </div>
        </TabPanel>
    );
};

export default RegularCustomersRange;
